import _slicedToArray from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
function useToggle(initialValue, options) {
  var _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var toggle = function toggle(value) {
    if (typeof value !== "undefined") {
      setState(value);
    } else {
      setState(function (current) {
        if (current === options[0]) {
          return options[1];
        }
        return options[0];
      });
    }
  };
  return [state, toggle];
}
function useBooleanToggle() {
  var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return useToggle(initialValue, [true, false]);
}
export { useBooleanToggle, useToggle };